<template>
  <CModal :show.sync="isOpenModal" addContentClasses="px-4 py-4" :closeOnBackdrop="false">
    <template #header-wrapper>
      <h5>{{ $t('quick.sms.modal.title') }}</h5>
    </template>
    <template #body-wrapper>
      <div class="py-5">
        <transition name="fade">
          <MenssageAlert :messages="messages" />
        </transition>
        <QuickSMSForm ref="quickSMSForm" @validation-change="handleValidationChange" />
      </div>
    </template>
    <template #footer-wrapper>
      <div class="text-right">
        <CButton class="px-4 py-2 mr-3" color="white" @click="cancelClick()" :disabled="isSubmitLoading">
          {{ $t('quick.sms.modal.button.cancel') }}
        </CButton>
        <CButton class="px-4 py-2" color="primary" @click="submitForm()" :disabled="isSubmitLoading || !isQuickSMSFormValid">
          <CSpinner v-if="isSubmitLoading" class="mr-1 align-middle" style="width: 1rem; height: 1rem" />
          {{ $t('quick.sms.modal.button.send') }}
        </CButton>
      </div>
    </template>
  </CModal>
</template>

<script>
import QuickSMSForm from './QuickSMSForm'
import MenssageAlert from '@/components/MenssageAlert'
import services from '@/services.js'

export default {
  name: 'QuickSMSModal',
  components: { QuickSMSForm, MenssageAlert },
  props: {
    dateFieldsList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      isOpenModal: false,
      isQuickSMSFormValid: false,
      isSubmitLoading: false,
      messages: [],
    }
  },
  methods: {
    openModal() {
      this.isOpenModal = true
    },
    closeModal() {
      this.isOpenModal = false
    },
    cancelClick() {
      this.closeModal()
      this.$refs.quickSMSForm.clearForm()
    },
    handleValidationChange(isValid) {
      this.isQuickSMSFormValid = isValid
    },
    getForm() {
      return this.$refs.quickSMSForm.getForm()
    },
    async submitForm() {
      try {
        this.isSubmitLoading = true

        const organizationId = this.$route.params.organizationId
        const payload = {
          organizationId,
          messages: [this.$refs.quickSMSForm.getForm()],
        }

        await services.sendQuickSMSJwt(payload)

        this.messages = [
          {
            status: 'success',
            text: this.$t('quick.sms.modal.success'),
          },
        ]

        await new Promise((resolve) => setTimeout(resolve, 2000))
        this.closeModal()
        this.messages = []
        this.$refs.quickSMSForm.clearForm()
      } catch (error) {
        const errorCode = error?.response?.data?.error?.code || error?.response?.data?.messages[0]?.error?.code

        if (!errorCode) {
          this.messages = [
            {
              status: 'danger',
              text: this.$t(`error.codes.DEFAULT`),
            },
          ]
          return
        }

        this.messages = [
          {
            status: 'danger',
            text: this.$t(`general.errors.${errorCode}`),
          },
        ]
      } finally {
        this.isSubmitLoading = false
      }
    },
  },
}
</script>
